import { KpiOther } from "../../types/kpi";
import labels from "../../utils/labels";
import KPITextLine from "../UI/kpi/KPITextLine";
import KpiCard from "./KpiCard";
import { ReactComponent as GraphBarsIcon } from "../../assets/icons/graph_bars.svg";
import ComparisonChip from "../UI/chips/ComparisonChip";
import KpiComparisonDistance from "./KpiComparisonDistance";

const KeyNumbersCard = ({
  kpiList,
  compare,
  compareKpiList,
}: {
  kpiList: KpiOther;
  compare: boolean;
  compareKpiList: KpiOther;
}) => {
  return (
    <KpiCard
      title={labels.keyNumbers}
      icon={<GraphBarsIcon />}
      classes="w-[40%]"
    >
      <KPITextLine
        compare={compare}
        title={labels.plannedEmployees}
        value={`${kpiList.plannedEmployees.toString()} ud af ${kpiList.totalEmployees.toString()}`}
      >
        {compare && (
          <ComparisonChip
            positiveIndicator="NEGATIVE"
            value={kpiList.plannedEmployees - compareKpiList.plannedEmployees}
            id={compareKpiList.plannedEmployees}
          />
        )}
      </KPITextLine>
      <KPITextLine
        compare={compare}
        title={labels.unplannedVisits}
        value={`${kpiList.unplannedVisits.toString()} ud af ${kpiList.totalVisits.toString()}`}
      >
        {compare && (
          <ComparisonChip
            positiveIndicator="NEGATIVE"
            value={kpiList.unplannedVisits - compareKpiList.unplannedVisits}
            id={compareKpiList.unplannedVisits}
          />
        )}
      </KPITextLine>
      <KPITextLine
        compare={compare}
        title={labels.unplannedEmployeeAppointments}
        value={`${kpiList.unplannedCalendarEvents.toString()} ud af ${kpiList.totalCalendarEvents.toString()}`}
      >
        {compare && (
          <ComparisonChip
            positiveIndicator="NEGATIVE"
            value={
              kpiList.unplannedCalendarEvents -
              compareKpiList.unplannedCalendarEvents
            }
            id={compareKpiList.unplannedCalendarEvents}
          />
        )}
      </KPITextLine>
      <KPITextLine
        compare={compare}
        title={labels.transportation}
        value={`${kpiList.drivenKilometers.toString()} km`}
      >
        {compare && (
          <KpiComparisonDistance
            value={kpiList.drivenKilometers}
            compareValue={compareKpiList.drivenKilometers}
          />
        )}
      </KPITextLine>
    </KpiCard>
  );
};

export default KeyNumbersCard;
